import { render, staticRenderFns } from "./gonglue.vue?vue&type=template&id=1d8af106"
import script from "./gonglue.vue?vue&type=script&lang=js"
export * from "./gonglue.vue?vue&type=script&lang=js"
import style0 from "./gonglue.vue?vue&type=style&index=0&id=1d8af106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports